export default __webpack_public_path__ + "static/media/hero-thumb-5.0aa681bd.png";